export default __webpack_public_path__ + "static/media/project2.aa06ff3c.png";